import styled from 'styled-components'

const AdvantagesContainer = styled.div<{
    isReversed?: boolean
    backgroundColor?: string
    noPadding?: boolean
}>`
    padding: ${({ noPadding }) => (noPadding ? '0' : '15px 50px')};
    background-color: ${({ backgroundColor }) => backgroundColor || 'transparent'};
    width: 100%;

    .content-section {
        display: grid;
        grid-template-columns: 1.5fr 1fr;
        gap: 0px;
        padding: ${({ noPadding }) => (noPadding ? '0' : '50px')};
        justify-content: space-around;
        ${({ isReversed }) =>
            isReversed &&
            `
            direction: rtl;
            > * {
            direction: ltr;
            }
            `}
        @media (max-width: 1050px) {
            grid-template-columns: 1fr;
        }
    }

    .hidden-mobile {
        @media (max-width: 1050px) {
            display: none !important;
        }
    }

    .hidden-desktop {
        @media (min-width: 1050px) {
            display: none !important;
        }
    }

    .text-section {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        width: 75%;
        gap: 25px;
        button {
            width: fit-content;
        }
        p {
            line-height: 1.7;
        }
        @media (max-width: 1050px) {
            width: 100%;
        }
    }

    .tagline {
        font-weight: 600;
        text-transform: uppercase;
    }

    .media-section {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: ${({ isReversed }) => (isReversed ? 'flex-start' : 'flex-end')};
        width: 100%;
        padding: 0 20%;
        gap: 35px;
        video {
            max-width: 100%;
            height: auto;
            border-radius: 12px;
        }
        @media (max-width: 1050px) {
            padding: 0;
            justify-content: center;
            padding-bottom: 25px;
        }
    }

    @media (max-width: 1050px) {
        padding: ${({ noPadding }) => (noPadding ? '0' : '25px')};
        .text-section-inner {
            width: 100%;
        }
        width: 100%;
        .content-section {
            grid-template-columns: 1fr;
            padding: 32px;
            gap: 32px;
        }
        .text-section {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;

            > div:first-child {
                align-items: center;
            }

            button {
                order: 1;
                margin-top: 20px;
            }
        }
        section {
            width: 100%;
            padding: 0 !important;
        }
        video {
            width: 300px !important;
            height: auto !important;
            padding: 0 !important;
        }
    }
`

export default AdvantagesContainer
